// Palette ported from the analyse_local.tsx mockup. Five section colors
// (`P`) with matching pastel backgrounds (`B`). Used by all section
// components so the look is preserved 1:1.
export const PALETTE = ["#378ADD", "#1D9E75", "#639922", "#0891B2", "#BA7517", "#7F77DD"] as const;
export const BG_PALETTE = ["#E6F1FB", "#E1F5EE", "#EAF3DE", "#E0F2FE", "#FAEEDA", "#EEEDFE"] as const;

export const CHART_COLORS = [
  PALETTE[0],
  PALETTE[1],
  PALETTE[2],
  PALETTE[3],
  PALETTE[4],
  "#D4537E",
  "#7A9E7E",
  "#C17C74",
] as const;

export const SECTION_TITLES = [
  "Fondamentaux",
  "Offre existante",
  "Équipements",
  "Interdépendances",
  "Manques",
  "Idées",
] as const;

export function parseDistance(str: string | null | undefined): number {
  if (!str) return Number.POSITIVE_INFINITY;
  const n = parseFloat(str.replace(",", "."));
  if (Number.isNaN(n)) return Number.POSITIVE_INFINITY;
  return str.toLowerCase().includes("km") ? n * 1000 : n;
}
